import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/button';

const FinalCTA = () => {
  const whatsappNumber = "5585985195369";
  const whatsappMessage = "Olá! Gostaria de solicitar um orçamento.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section className="py-16 bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6]">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Precisa de impressão, assistência técnica, papelaria ou carimbos?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Solicite seu orçamento pelo WhatsApp. Atendimento rápido em Fortaleza.
        </p>
        <Button
          onClick={() => window.open(whatsappLink, '_blank')}
          size="lg"
          className="bg-[#25D366] hover:bg-[#20BD5C] text-white font-bold px-10 py-6 text-lg shadow-2xl hover:shadow-[#25D366]/50 transition-all hover:scale-105"
        >
          <Phone className="w-6 h-6 mr-2" />
          Falar no WhatsApp
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;
